import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { IIconComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

export enum SbFormatCardStatus {
  NoStoreAvailable,
  NoStoreSpotlightStoreAvailable,
  StoreSpotlightFormatNotAvailable,
  ManualCollectionFormatNotAvailable,
}

const SbFormatCardStatusLabels: Record<SbFormatCardStatus, string> = {
  [SbFormatCardStatus.NoStoreAvailable]: "sb-form-ad-format.no_store_available",
  [SbFormatCardStatus.NoStoreSpotlightStoreAvailable]: "sb-form-ad-format.no_store_spotlight_store",
  [SbFormatCardStatus.StoreSpotlightFormatNotAvailable]: "sb-form-ad-format.no_store_spotlight_format_for_tacos",
  [SbFormatCardStatus.ManualCollectionFormatNotAvailable]: "sb-form-ad-format.no_manual_collection_format_available",
};

@Component({
  selector: "app-sb-format-card-status",
  imports: [IIconComponent, TranslocoDirective],
  template: `
    <p class="type-label text-muted-foreground mt-2" *transloco="let t">
      <span class="align-middle"><IIcon name="infoCircle" /></span>
      @if (
        status() === SbFormatCardStatus.NoStoreAvailable ||
        status() === SbFormatCardStatus.NoStoreSpotlightStoreAvailable
      ) {
        {{ t(SbFormatCardStatusLabels[status()], [brandName() ?? ""]) }}
      } @else {
        {{ t(SbFormatCardStatusLabels[status()]) }}
      }
    </p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbFormatCardStatusComponent {
  status = input.required<SbFormatCardStatus>();
  brandName = input<string>();

  readonly SbFormatCardStatusLabels = SbFormatCardStatusLabels;
  readonly SbFormatCardStatus = SbFormatCardStatus;
}
